import { getAliasString } from '@/utils/common';

export const getCurrentAliasPage = (path: string | string[]) => {
  return getAliasString(path).split('/').slice(-1).join('');
};

export const convertActivePath = (path: string) => {
  return path === 'blog' ? '' : path.split('/').slice(-1).join('');
};
